import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
export function Layout() {
  return <div className="flex h-screen w-full overflow-hidden bg-slate-50 font-[Inter] text-evergreen" data-id="element-2473" data-mp="2rd1ivlq10kzy">
      <Sidebar data-id="element-2474" data-mp="2vcinkcxmpe42" />
      <main className="flex min-w-0 flex-1 flex-col overflow-hidden" data-id="element-2475" data-mp="2vc0nt6brchre">
        <Outlet data-id="element-2476" data-mp="304k1s4ecxewq" />
      </main>
    </div>;
}